import InputWithSearch from "../InputWithSearch";
import CustomSelect from "../CustomSelect";
import Button from "../Button";
import classes from "./SearchWithControls.module.css"

const SearchWithControls = ({
    customerSearchState,
    onSearchInputChange,
    onSearchByChange,
    onSearchCustomers,
    onClearSearch,
    dropdownData,
    className
  }) => {
    return (
      <div className={className}>
        <InputWithSearch
          className={classes["customer-search-box"]}
          placeholder="Search"
          value={customerSearchState?.searchValue}
          onChange={onSearchInputChange}
        />
        <CustomSelect
          className={classes["search-by-select"]}
          value={customerSearchState?.searchByValue}
          onChange={onSearchByChange}
          data={dropdownData}
          optionLabel="label"
          optionValue="value"
          placeholder="Select search by"
        />
        <Button
          onClick={onSearchCustomers}
          disabled={!customerSearchState?.searchValue}
        >
          Search
        </Button>
        <Button
          onClick={onClearSearch}
          disabled={!customerSearchState?.searchValue}
        >
          Clear
        </Button>
      </div>
    );
  };
  
  export default SearchWithControls;